
function isBoldRendered() {
  return window.isBoldRendered === true;
}

function onBoldReady() {
  if (typeof BOLD === 'undefined') requestAnimationFrame(onBoldReady);
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (data) {
    window.isBoldRendered = true;
    if (window.boldFixed) return;
    preventAccidentalFormSubmission();
    fixOptions();
    addAccordionReveal();
    handleBoldSelectChange();
    window.boldFixed = true;
  });
}
onBoldReady();

function removeDoubleDashesFromOptions(option) {
  option.textContent = option.textContent.replaceAll("--", "");
}

function setMarketPrice(option) {
  if (window.Shopify.currency.rate == null) return;
  const regex = new RegExp(/\d+\.\d{2}/gm);
  const amount = option.textContent.match(regex)?.[0];
  const amountAsNumber = parseFloat(amount);
  if (!amount || isNaN(amount)) return;
  const exchangeRateMultiplier = parseFloat(window.Shopify.currency.rate);
  const marketPrice = amountAsNumber * exchangeRateMultiplier;
  option.textContent = option.textContent.replace(
    amount,
    marketPrice.toFixed(2)
  );
}

function fixOptions() {
  document.querySelectorAll(".bold_option_element").forEach((ele) => {
    ele.querySelectorAll("select option, .bold_option_value_price").forEach((option) => {
      removeDoubleDashesFromOptions(option);
      setMarketPrice(option);
    });
  });
}

function addAccordionReveal() {
  const personalisationFields = document.querySelectorAll(
    ".bold_option_set .bold_option"
  );
  if (personalisationFields.length <= 4) return;
  const productForm = document.querySelector(".product-purchase-form");
  if (!productForm) return;
  productForm.classList.add("reveal");

  const newButton = document.createElement("button");
  const newContent = document.createTextNode("Personalise & Buy");
  newButton.appendChild(newContent);

  newButton.classList.add("reveal-button");
  productForm.appendChild(newButton);

  const boldWrapper = document.querySelector('.bold_options_loaded');

  boldWrapper.addEventListener('click',e=>{
    productForm.classList.remove("reveal");
    newButton.remove();
  })

  newButton.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      productForm.classList.remove("reveal");
      newButton.remove();
    },
    { once: true }
  );
}

function handleBoldSelectChange() {
  document.querySelectorAll('.product-purchase-form .bold_option_element').forEach(select => {
    document.addEventListener('change', ({target}) => {
      const selectedOption = target.querySelector(
        `option[value="${target.value}"]`
      );

      if (selectedOption == null) return;

      const parent = target.closest('.bold_option_element')
  
      const { variantName, price } = extractVariantAndAmount(selectedOption.innerText);
      parent.dataset.selectedOption = variantName;
  
      parent.dataset.extraCost = price;
  
      if (!price) parent.removeAttribute("data-extra-cost");
    })
  })
}

function preventAccidentalFormSubmission() {
  var form = document.querySelector('.product-purchase-form');

  form.addEventListener('submit', function (e) {
    const optionsDropdownContainers = document.querySelectorAll('.bold_option_dropdown');
  
    // add a loader to the submit button
    const submitButtons = document.querySelectorAll('[data-loader-after-click]');
    if (submitButtons.length > 0) {
      submitButtons.forEach((button) => {
        // store the original text
        button.dataset.originalText = button.innerHTML;
        // spinner icon from Phosphor Icons
        button.innerHTML = '<div class="submit-spinner"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z"></path></svg><span>';
        button.style.paddingTop = '13px';
        button.style.paddingBottom = '13px';
      });
    }
  
    for (var i = 0; i < optionsDropdownContainers.length; i++) {
      var selectEle = optionsDropdownContainers[i].getElementsByTagName('select')[0];
      var currentActiveEle = document.activeElement;
  
      if (selectEle == currentActiveEle) {
        e.preventDefault();

        // put the original text back if the form submission is prevented
        if (submitButtons.length > 0) {
          submitButtons.forEach((button) => {
            // if the original text dataset is set then put it back
            if (button.dataset.originalText) {
              button.innerHTML = button.dataset.originalText;
              button.style.paddingTop = '';
              button.style.paddingBottom = '';
            }
          });
        }
        return false;
      }
    }

  });

}




function extractVariantAndAmount(str) {
  const regex = /(.*)\s\[\+?([\+\-\u00A3\u0024€¥]\d+(?:[.,]\d{2}))\]/;
  const match = str.match(regex);
  if (!match) return {};
  return {
    variantName: match[1].trim(),
    price: match[2],
  };
}

function setVisibilityOfLeatherCoverColourSwatches(visible = true) {
  // find the bold option called Leather Keepsake Cover, this is a bit riduculous but there are no better selectors
  try {
    let leatherOptionSection = Array.from(
      document.querySelectorAll("div.bold_option_title")
    ).find((el) => el.innerText.indexOf("Leather Keepsake") > -1);
    if (leatherOptionSection == null) return false;

    let leatherOptions = leatherOptionSection.closest("div.bold_option");

    // hide the leather colour selector
    if (visible) {
      leatherOptions.classList.remove("hidden");
      // re-enable the properties field
      let propertiesField = document.querySelector(
        '[data-disabled-field-name="properties[Leather Keepsake Colour]"]'
      );
      if (propertiesField !== null) {
        // change the [data-disabled-field-name="properties[Leather Keepsake Colour]"] to [name="properties[Leather Keepsake Colour]"]
        propertiesField.setAttribute(
          "name",
          "properties[Leather Keepsake Colour]"
        );
        propertiesField.removeAttribute("data-disabled-field-name");
      }
    } else {
      leatherOptions.classList.add("hidden");
      // disable the properties field by changing [name="properties[Leather Keepsake Colour]"] to [data-disabled-field-name="properties[Leather Keepsake Colour]"]
      let propertiesField = document.querySelector(
        '[name="properties[Leather Keepsake Colour]"]'
      );
      if (propertiesField !== null) {
        propertiesField.setAttribute(
          "data-disabled-field-name",
          "properties[Leather Keepsake Colour]"
        );
        propertiesField.removeAttribute("name");
      }
    }
  } catch (e) {
    return false;
  }

  return true;
}

function getCoverValue() {
  if (
    document.querySelector('div.option-selector[data-option-name="Cover"]') ==
    null
  )
    return "";
  let selectedValue = document
    .querySelector('div.option-selector[data-option-name="Cover"]')
    .querySelector("input[type=radio]:checked");
  if (selectedValue == null) return "";
  return selectedValue.value;
}

// hide the leather options on page load
// document.addEventListener("DOMContentLoaded", function (event) {
//   // find the bold option called Leather Keepsake Cover, this is a bit riduculous but there are no better selectors
//   let numberOfIntervals = 0;
//   let waitForLeatherCoverSelector = setInterval(() => {
//     if (isBoldRendered()) {
//       const coverValue = getCoverValue();
//       if (coverValue == "") return;

//       let visibility = false;
//       if (coverValue.indexOf("Leather") > -1) {
//         visibility = true;
//       }
//       if (
//         setVisibilityOfLeatherCoverColourSwatches(visibility) ||
//         numberOfIntervals > 3000
//       ) {
//         clearInterval(waitForLeatherCoverSelector);
//       }
//     }
//   }, 50);
// });

// Code below to show new delivery dates, automated to show hardcover or softcover based on selection
document.addEventListener("cc-variant-updated", (event) => {
  if (
    event.detail == null ||
    event.detail.variant == null ||
    event.detail.variant.option1 == null
  )
    return; // no data

  const variantType = event.detail.variant.option1;
  const dispatchDateInput = document.querySelector(
    '[name="properties[Dispatch date]"]'
  );

  // if its the leather keepsake cover then show the leather colour selector
  if (variantType.indexOf("Leather") > -1) {
    // show the leather colour selector
    setVisibilityOfLeatherCoverColourSwatches(true);
  } else {
    // hide the leather colour selector
    setVisibilityOfLeatherCoverColourSwatches(false);
  }

  if (variantType == "Hardcover" || variantType == "Leather Keepsake Cover") {
    document
      .querySelectorAll(
        '.last-order-banner[data-book-variant-type="book_softcover"]'
      )
      .forEach((el) => {
        el.style.display = "none";
      });

    document
      .querySelectorAll(
        '.last-order-banner[data-book-variant-type="book_hardcover"]'
      )
      .forEach((el) => {
        el.style.display = "inline-flex";
      });

    document
      .querySelectorAll(".shipping-dates")
      .forEach((el) => el.classList.add("show-hardcover"));

    if (dispatchDateInput != null) {
      dispatchDateInput.value = dispatchDateInput.dataset.makeTimeHardCoverDate;
    }
  } else {
    document
      .querySelectorAll(
        '.last-order-banner[data-book-variant-type="book_softcover"]'
      )
      .forEach((el) => {
        el.style.display = "inline-flex";
      });

    document
      .querySelectorAll(
        '.last-order-banner[data-book-variant-type="book_hardcover"]'
      )
      .forEach((el) => {
        el.style.display = "none";
      });

    document
      .querySelectorAll(".shipping-dates")
      .forEach((el) => el.classList.remove("show-hardcover"));

    if (dispatchDateInput != null) {
      dispatchDateInput.value = dispatchDateInput.dataset.makeTimeSoftCoverDate;
    }
  }
});
